import { motion } from "framer-motion";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/sections/Hero";
import ExploreTiles from "@/sections/ExploreTiles";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, EASE } from "@/components/motion";

export default function Home() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: EASE }}
      className="bg-paper"
    >
      <Nav />
      <main>
        <Hero />
        <ExploreTiles />
        <section className="border-t border-hairline" data-testid="home-cta">
          <div className="mx-auto flex max-w-[1400px] flex-col gap-8 px-6 py-20 sm:flex-row sm:items-end sm:justify-between sm:px-10 sm:py-24">
            <div>
              <Reveal>
                <p className="overline-label">Open to the right opportunity</p>
              </Reveal>
              <Reveal delay={0.08}>
                <h2 className="mt-4 font-serif text-4xl sm:text-5xl font-light leading-tight text-ink">
                  Let's talk <em className="text-moss">hospitality.</em>
                </h2>
              </Reveal>
            </div>
            <Reveal delay={0.15}>
              <Link
                to="/contact"
                data-testid="home-cta-contact"
                className="group inline-flex w-fit items-center gap-2 bg-moss px-7 py-3.5 text-[12px] font-semibold uppercase tracking-[0.18em] text-paper transition-colors duration-300 hover:bg-ink"
              >
                Get in Touch
                <ArrowRight size={14} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Reveal>
          </div>
        </section>
      </main>
      <Footer />
    </motion.div>
  );
}
